import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  error?: string;
  type?: 'text' | 'number' | 'email' | 'password' | 'textarea' | 'date';
}
export function Input({
  className = '',
  label,
  error,
  type = 'text',
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  const baseStyles = 'flex w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50';
  const errorStyles = error ? 'border-red-500 focus:ring-red-500' : '';
  return <div className="w-full space-y-1.5" data-id="element-1195">
      {label && <label htmlFor={inputId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700" data-id="element-1196">
          {label}
        </label>}
      {type === 'textarea' ? <textarea id={inputId} className={`${baseStyles} min-h-[80px] ${errorStyles} ${className}`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-1197" /> : <input id={inputId} type={type} className={`${baseStyles} ${errorStyles} ${className}`} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-1198" />}
      {error && <p className="text-xs text-red-500 font-medium" data-id="element-1199">{error}</p>}
    </div>;
}